export default {
    lectures: null,
    students: null,
    chat: null,
    messages: null,
};
